import * as React from "react";
import { useTranslation } from 'react-i18next';

const fields = {

        config: { columns: 1 },
        fields: [
            {
                name: "selectedTemplate",
                label: "formConfig.template",
                mandatory: true,
                column: 1,
                type: "dictionary",
                dictionary: "toolSetTemplate",
                selectObject: true,
                render: function(d) {
                    return `${d.templateName} ${d.internalNumber ? d.internalNumber : ""}`
                }
            }

        ]


    };

export default fields;